import React, { useEffect } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Balance from './components/Balance'
import './components/style.scss'
import { BalanceWrapperProps } from './BalanceProps'
import { getUserSelector } from '../../Redux/selectors/auth'
import {
  locationEvent,
  pageInfo,
  pageViewEvent,
} from '../../Helpers/tagManager'

const BalanceWrapper: React.FunctionComponent<BalanceWrapperProps> = ({
  getAllTransactions,
  orderPayout,
  recipient,
  balance,
  curator,
  hasAwaiting,
}) => {
  const { t } = useTranslation()

  const user = useSelector(getUserSelector)

  useEffect(() => {
    if (user) {
      pageViewEvent(user, pageInfo.balance)
      locationEvent()
    }
  }, [user])

  return (
    <Container className="balance-wrapper">
      <Col>
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('balancePage.pageTitle')}</h3>
          </Col>
        </Row>
        <Balance
          balance={balance}
          orderPayout={orderPayout}
          recipient={recipient}
          getAllTransactions={getAllTransactions}
          complaints={curator.complaints}
          hasAwaiting={hasAwaiting}
          curator={curator}
        />
      </Col>
    </Container>
  )
}

export default BalanceWrapper
